import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import pump1 from '../Images/syringeinjection.jpeg';
import pump2 from '../Images/volumeinjection.jpeg';
import HeaderImage from '../Images/injectionpage.jpg';

import FacebookIcon from '../Images/facebook.png';
import TwitterIcon from '../Images/twitter.png';
import LinkedInIcon from '../Images/linkedin.png';
import InstagramIcon from '../Images/instagram.png';
import Footer from './Footer';

const imageDetails = {
  [pump1]: {
    category: 'Syringe Infusion Pumps',
    heading: ' Infusion Pump',
    title: 'Model : MT 40',
    description:
      'MT 40 is a smart and reliable infusion pump system designed for accurate fluid delivery, enhanced patient safety, and smooth clinical workflow. With intelligent monitoring functions, dual CPU protection, pressure monitoring, and large history storage capacity, it delivers dependable performance for hospitals, ICUs, emergency care, and clinical applications.',
    sections: {
  "Easier & Smarter Operation": {
    icon: "🖥️",
    items: [
      "User-friendly operating interface",
      "Simple and efficient workflow management",
      "Fast parameter setup and monitoring",
      "Intelligent control system for smooth operation",
      "Designed for continuous clinical use",
    ],
  },

  "Advanced Safety Design": {
    icon: "🛡️",
    items: [
      "Auto-lock screen prevents accidental operation",
      "Dual CPU system ensures safe and more stable performance",
      "Intelligent alarm and monitoring functions",
      "Enhanced protection during infusion operation",
      "Reliable medical-grade safety system",
    ],
  },

  "Intelligent Monitoring & Control": {
    icon: "📊",
    items: [
      "Pressure monitoring with 3 adjustable pressure levels",
      "Real-time system monitoring and alerts",
      "Accurate fluid delivery performance",
      "Continuous operation status tracking",
      "Stable and dependable infusion management",
    ],
  },

  "Smart Self-Test Function": {
    icon: "🔄",
    items: [
      "Automatic system self-test during startup",
      "Monitors alarm functionality",
      "Checks pressure system performance",
      "Detects air bubbles for safer infusion",
      "Ensures reliable operation before use",
    ],
  },

  "Data & History Management": {
    icon: "📁",
    items: [
      "History record capacity support",
      "Stores up to 2000 records",
      "Easy review and tracking of infusion history",
      "Supports efficient hospital workflow management",
      "Reliable data storage and access",
    ],
  },

  "Reliable Clinical Performance": {
    icon: "🏥",
    items: [
      "Suitable for ICU, OR, emergency, and ward applications",
      "Stable long-duration operation",
      "Compact and durable construction",
      "Designed for modern healthcare environments",
      "Portable and easy-to-handle system",
    ],
  },
},
  },
  [pump2]: {
    // heading: 'Volumetric Infusion Pump',
    heading: 'Infusion Pump',
    category: 'Volumetric Infusion Pumps',
    title: 'Model : MT 50',
    description:
      'MT 50 is an intelligent and high-performance infusion pump designed for precise fluid delivery, advanced safety monitoring, and efficient clinical workflow management. Equipped with smart infusion control features, real-time pressure monitoring, customizable safety settings, and extensive history storage, it delivers reliable performance for hospitals, ICUs, emergency care, and modern healthcare environments.',
    sections: {
  "Smart & Continuous Infusion Control": {
    icon: "💉",
    items: [
      "Titration function allows flow rate changes without stopping infusion",
      "Ideal total volume during operation without interruption",
      "Smooth and efficient infusion workflow",
      "Designed for accurate and continuous medication delivery",
      "User-friendly operation for clinical environments",
    ],
  },

  "Advanced Safety Protection": {
    icon: "🛡️",
    items: [
      "Anti-bolus technology automatically reduces pressure after occlusion",
      "Adjustable bubble detection system for enhanced patient safety",
      "Screen lock prevents accidental operation",
      "Adjustable occlusion and air bubble levels",
      "Auto stop function in Micro Mode for safe infusion management",
    ],
  },

  "Intelligent Monitoring System": {
    icon: "📊",
    items: [
      "DPS real-time pressure graph and pressure value display",
      "Continuous monitoring of infusion performance",
      "Adjustable alarm volume and display brightness",
      "Standby mode with adjustable timing",
      "Stable and reliable clinical operation",
    ],
  },

  "Drug Library & Therapy Management": {
    icon: "💊",
    items: [
      "Built-in drug library supporting more than 30 drugs",
      "Last therapy memory stores previous settings for quick reuse",
      "Faster setup and improved workflow efficiency",
      "Suitable for various clinical infusion applications",
    ],
  },

  "Purge & Bubble Detection": {
    icon: "🫧",
    items: [
      "Purge function removes air bubbles efficiently",
      "Adjustable bubble detector sensitivity",
      "Enhances infusion safety and accuracy",
      "Supports single and accumulated bubble detection within 15 minutes",
    ],
  },

  "Data & History Storage": {
    icon: "📁",
    items: [
      "Stores over 2000 history records",
      "Easy review and tracking of infusion data",
      "Efficient monitoring and documentation support",
      "Reliable record management for hospital workflow",
    ],
  },

  "Reliable Clinical Performance": {
    icon: "🏥",
    items: [
      "Compact and durable medical-grade design",
      "Suitable for ICU, OR, emergency, and ward applications",
      "Stable long-duration performance",
      "Designed for modern healthcare requirements",
    ],
  },
},
  },
};

const SyringeInfusionpumpDetail = () => {
  const allImages = [pump1, pump2];
  const [mainImage, setMainImage] = useState(pump1);
  const [relatedImages, setRelatedImages] = useState(allImages.filter((img) => img !== pump1));
  const [isMobile, setIsMobile] = useState(false);
  const introRef = useRef(null);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = (clickedImage) => {
    setMainImage(clickedImage);
    setRelatedImages(allImages.filter((img) => img !== clickedImage));
    setTimeout(() => {
      introRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  const detail = imageDetails[mainImage];
  const sections = detail?.sections || {};

  return (
    <div style={{ fontFamily: 'sans-serif', margin: 0, padding: 0, overflowX: 'hidden' }}>

      {/* ── HERO ── */}
      <div style={{
        height: isMobile ? '30vh' : '80vh',
        width: '100%',
        overflow: 'hidden',
        position: 'relative',
      }}>
        <img
          src={HeaderImage}
          alt="Hero"
          style={{ width: '100%', height: '100%', objectFit: 'fill', display: 'block' }}
        />
        <div style={{
          position: 'absolute', inset: 0,
          background: 'linear-gradient(to top, rgba(0,20,60,0.5) 0%, transparent 60%)',
        }} />
      </div>

      {/* ── PRODUCT INTRO ── */}
      <div ref={introRef} style={{
        display: 'flex',
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        gap: '40px',
        padding: isMobile ? '32px 6%' : '48px 6%',
        alignItems: 'flex-start',
      }}>
        {/* Left: text */}
        <div style={{ flex: 1, minWidth: '260px' }}>
          <div style={{
            display: 'inline-block',
            backgroundColor: '#e8f0fe',
            color: '#1a56db',
            fontSize: '13px',
            fontWeight: '600',
            padding: '4px 14px',
            borderRadius: '20px',
            marginBottom: '14px',
          }}>
            {detail?.category}
          </div>
          <h1 style={{
            fontSize: isMobile ? '26px' : '38px',
            fontWeight: '800',
            color: '#0a1628',
            margin: '0 0 8px',
            lineHeight: 1.2,
          }}>
            {detail?.title}
          </h1>
          <h2 style={{
            fontSize: isMobile ? '16px' : '20px',
            fontWeight: '500',
            color: '#444',
            margin: '0 0 20px',
          }}>
            {detail?.heading}
          </h2>
          <p style={{ fontSize: '15px', color: '#555', lineHeight: '1.8', maxWidth: '520px' }}>
            {detail?.description}
          </p>
        </div>

        {/* Right: product image */}
        <div style={{
          flex: '0 0 auto',
          width: isMobile ? '100%' : '340px',
          background: '#f4f6fb',
          borderRadius: '14px',
          padding: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <img
            src={mainImage}
            alt="Infusion Pump"
            style={{ width: '100%', maxHeight: '260px', objectFit: 'contain', borderRadius: '8px' }}
          />
        </div>
      </div>

      {/* ── KEY FEATURES GRID ── */}
      <div style={{ padding: isMobile ? '16px 6% 40px' : '16px 6% 56px' }}>
        <div style={{ width: '50px', height: '5px', backgroundColor: '#cc0000', borderRadius: '2px', marginBottom: '12px' }} />
        <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#0a1628', marginBottom: '28px' }}>
          Key Features
        </h2>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: '20px',
        }}>
          {Object.entries(sections).map(([sectionName, sectionData], idx) => (
            <div key={idx} style={{ background: '#f4f6fb', borderRadius: '12px', padding: '22px 20px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
                <span style={{ fontSize: '20px' }}>{sectionData.icon}</span>
                <h3 style={{ fontSize: '15px', fontWeight: '700', color: '#0a1628', margin: 0 }}>
                  {sectionName}
                </h3>
              </div>
              <ul style={{ margin: 0, paddingLeft: '18px', listStyle: 'disc' }}>
                {sectionData.items.map((item, i) => (
                  <li key={i} style={{ fontSize: '13px', color: '#555', lineHeight: '1.8' }}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* ── RELATED PRODUCTS ── */}
      {relatedImages.length > 0 && (
        <div style={{ padding: isMobile ? '0 6% 48px' : '0 6% 60px' }}>
          <div style={{ width: '50px', height: '5px', backgroundColor: '#cc0000', borderRadius: '2px', marginBottom: '12px' }} />
          <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#0a1628', marginBottom: '24px' }}>
            Related Products
          </h2>
          <div style={{
            display: 'flex',
            gap: '20px',
            overflowX: 'auto',
            overflowY: 'hidden',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            paddingBottom: '4px',
          }}>
            {relatedImages.map((img, index) => (
              <div
                key={index}
                onClick={() => handleImageClick(img)}
                style={{
                  flex: '0 0 auto',
                  width: '220px',
                  background: '#f4f6fb',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  transition: 'transform 0.2s, box-shadow 0.2s',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.13)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.07)';
                }}
              >
                <div style={{
                  padding: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '150px',
                }}>
                  <img
                    src={img}
                    alt={`Related ${index}`}
                    style={{ maxWidth: '100%', maxHeight: '120px', objectFit: 'contain' }}
                  />
                </div>
                <div style={{ background: '#001f4d', padding: '10px 14px' }}>
                  <p style={{ margin: 0, fontSize: '13px', color: '#fff', fontWeight: '600' }}>
                    {imageDetails[img]?.title || `Product ${index + 1}`}
                  </p>
                  <p style={{ margin: '4px 0 0', fontSize: '11px', color: '#aac4ff' }}>
                    {imageDetails[img]?.category}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

     <Footer/>

      <style>{`
        *::-webkit-scrollbar { display: none; }
        * { scrollbar-width: none; }
        body { overflow-x: hidden; }
      `}</style>
    </div>
  );
};

export default SyringeInfusionpumpDetail;